import React, {memo, useMemo} from "react";
import styles from './MainFooter.module.scss';
import {useTranslation} from "react-i18next";

function MainFooter() {
    const {t} = useTranslation();
    console.warn("FOOTER RENDERED")
    // year never changes during the session, so memoize it once
    const currentYear = useMemo(() => new Date().getFullYear(), []);

    return (
        <footer className={`${styles.footer} container-fluid px-3`}>
            <div className="row gx-0 gy-2 justify-content-xl-between align-items-center">
                <div className="col-12 col-xl-4">
                    <div>© {t("COMMON_Copyrights")} 2020-{currentYear}</div>
                </div>
                <div className="col-12 col-xl-auto">
                    <div className="row gx-0 gy-2 justify-content-xl-end gx-xl-3 align-items-cente">
                        <div className="col-6 col-xl-auto">
                            <a className={styles.footerAnchor} target="_blank" rel="noopener noreferrer"
                               href="https://flintgrp.com/en/privacy-statement/">{t("REGISTER_PRIVACY_POLICY")}</a>
                        </div>
                        <div className="col-6 col-xl-auto">
                            <a
                                className={styles.footerAnchor}
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://flintgrp.com/en/cookie-information/">
                                {t("LOGIN_COOKIE_POLICY")}
                            </a>
                        </div>
                        <div className="col-6 col-xl-auto">
                            <a
                                className={styles.footerAnchor}
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://www.flintgrp.com/pages/legal/conditions-of-sale/">
                                {t("COMMON_GeneralConditionsOfSale")}
                            </a>
                        </div>
                        <div className="col-6 col-xl-auto">
                            <a
                                className={styles.footerAnchor}
                                target="_blank"
                                rel="noopener noreferrer"
                                href="https://www.flintgrp.com/">
                                Flint Group
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

// Export the memoized version
export default memo(MainFooter);
